module.exports = __webpack_public_path__ + "static/media/coin3d-1.e4cd5200.png";